export default function (classNames) {
    let result = Object.keys(classNames).map(function (className) {
        if (classNames[className]) {
            return className;
        }

        return ""
    }).filter(s => s);

    if (result.length === 0) {
        return "";
    }

    return result.join(" ")
}